import * as React from 'react';
import BecomePartnerHero from './BecomePartnerHero';
import GoogleMap from 'components/GoogleMaps/GoogleMap';
import { POINZ_LATITUDE, POINZ_LONGITUTE } from 'utils/general';
import ContactCrispSection from 'containers/ContactUs/ContactCrispSection';
import BecomePartnerFormSection from './BecomePartnerFormSection';
import { ContentfulAsset } from 'model/contentful/asset';

interface Props {
  heroImage: ContentfulAsset;
}

const BecomePartner: React.FC<Props> = ({ heroImage }) => {
  return (
    <div className="ContactUs -mb-24 md:-mb-32 border-b-[1.5px] border-b-white">
      <BecomePartnerHero heroImage={heroImage} />
      <BecomePartnerFormSection />
      <GoogleMap
        className="w-full h-[600px]"
        zoom={20}
        location={{
          // @ts-expect-error wrongly typed google map lng and lat
          lat: POINZ_LATITUDE,
          // @ts-expect-error wrongly typed google map lng and lat
          lng: POINZ_LONGITUTE
        }}
      />
      <ContactCrispSection />
    </div>
  );
};

export default BecomePartner;
